export const ALMANAC_ASK = 'almanac:ask';

export interface AskAssistantDetail {
  /** pre-filled question to send immediately; omit to open with an empty input */
  question?: string;
  /** research artifact to ground the conversation in (assistant page_context) */
  researchId?: string;
}

/**
 * Open the Almanac assistant from anywhere inside the app shell (mirrors the
 * ALMANAC_DATA_CHANGED window-event pattern in data-events.ts). The shell's
 * command palette listens and transitions to its 'ask' page.
 */
export function askAlmanacAssistant(detail: AskAssistantDetail = {}): void {
  window.dispatchEvent(new CustomEvent(ALMANAC_ASK, { detail }));
}
